export default "__VITE_ASSET__CBYVQBAm__"